import "./polyfill";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const el = document.getElementById("root");
if (!el) {
  document.body.innerHTML =
    '<div style="padding:24px;font-family:system-ui;color:#f3f6ff;background:#0a0e17;min-height:100vh">无法挂载 #root</div>';
} else {
  try {
    createRoot(el).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  } catch (e) {
    const msg = e instanceof Error ? e.message : String(e);
    el.innerHTML = `<div style="padding:24px;font-family:system-ui;color:#ffb4b4;background:#0a0e17;min-height:100vh">
      <h2 style="color:#fff">启动失败</h2>
      <pre style="white-space:pre-wrap">${msg}</pre>
      <button onclick="location.reload()" style="margin-top:12px;padding:10px 16px;border-radius:10px;border:0;background:#2a6df4;color:#fff">刷新</button>
    </div>`;
    console.error(e);
  }
}
